/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Dashboard_View_Live_SiteInputs */

const en_seller_dashboard_view_live_site = /** @type {(inputs: Seller_Dashboard_View_Live_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Live Site`)
};

const es_seller_dashboard_view_live_site = /** @type {(inputs: Seller_Dashboard_View_Live_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver Sitio en Vivo`)
};

const fr_seller_dashboard_view_live_site = /** @type {(inputs: Seller_Dashboard_View_Live_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir le site en ligne`)
};

const de_seller_dashboard_view_live_site = /** @type {(inputs: Seller_Dashboard_View_Live_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Seite ansehen`)
};

const id_seller_dashboard_view_live_site = /** @type {(inputs: Seller_Dashboard_View_Live_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Situs Live`)
};

/** @type {(inputs: Seller_Dashboard_View_Live_SiteInputs) => LocalizedString} */
const ja_seller_dashboard_view_live_site = en_seller_dashboard_view_live_site;

/** @type {(inputs: Seller_Dashboard_View_Live_SiteInputs) => LocalizedString} */
const zh_seller_dashboard_view_live_site = en_seller_dashboard_view_live_site;

/** @type {(inputs: Seller_Dashboard_View_Live_SiteInputs) => LocalizedString} */
const ar_seller_dashboard_view_live_site = en_seller_dashboard_view_live_site;

/** @type {(inputs: Seller_Dashboard_View_Live_SiteInputs) => LocalizedString} */
const it_seller_dashboard_view_live_site = en_seller_dashboard_view_live_site;

/** @type {(inputs: Seller_Dashboard_View_Live_SiteInputs) => LocalizedString} */
const ru_seller_dashboard_view_live_site = en_seller_dashboard_view_live_site;

/** @type {(inputs: Seller_Dashboard_View_Live_SiteInputs) => LocalizedString} */
const pt_seller_dashboard_view_live_site = en_seller_dashboard_view_live_site;

/** @type {(inputs: Seller_Dashboard_View_Live_SiteInputs) => LocalizedString} */
const ko_seller_dashboard_view_live_site = en_seller_dashboard_view_live_site;

/**
* | output |
* | --- |
* | "View Live Site" |
*
* @param {Seller_Dashboard_View_Live_SiteInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_dashboard_view_live_site = /** @type {((inputs?: Seller_Dashboard_View_Live_SiteInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Dashboard_View_Live_SiteInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_dashboard_view_live_site(inputs)
	if (locale === "es") return es_seller_dashboard_view_live_site(inputs)
	if (locale === "fr") return fr_seller_dashboard_view_live_site(inputs)
	if (locale === "de") return de_seller_dashboard_view_live_site(inputs)
	if (locale === "ja") return ja_seller_dashboard_view_live_site(inputs)
	if (locale === "zh") return zh_seller_dashboard_view_live_site(inputs)
	if (locale === "ar") return ar_seller_dashboard_view_live_site(inputs)
	if (locale === "id") return id_seller_dashboard_view_live_site(inputs)
	if (locale === "it") return it_seller_dashboard_view_live_site(inputs)
	if (locale === "ru") return ru_seller_dashboard_view_live_site(inputs)
	if (locale === "pt") return pt_seller_dashboard_view_live_site(inputs)
	return ko_seller_dashboard_view_live_site(inputs)
});